import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";
import { StatusTag } from "../../../../../components/deprecated/StatusTag/StatusTag";

import { UserDeviceData } from "../../../User/UserDeviceData";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";

function getColorForPlatform(platform: string) {
  if (platform.toLowerCase() === "ios") return "blue";
  else if (platform.toLowerCase() === "web") return "red";
  return "green";
}

export class UserDeviceDataHelper extends DataObjectHelper<UserDeviceData> {
  id = () => "userDevice";

  platform = new FirebaseDataStringField<UserDeviceData>("platform", t("main.platform"), (userDevice) => userDevice.platform, "code");
  model = new FirebaseDataStringField<UserDeviceData>("model", t("main.model"), (userDevice) => userDevice.model, "devices");
  osVersion = new FirebaseDataStringField<UserDeviceData>("osVersion", t("main.osVersion"), (userDevice) => userDevice.osVersion, "dvr");

  lastLogin = new FirebaseDataDateField<UserDeviceData>("lastLogin", t("main.lastLogin"), (userDevice) => userDevice.lastLogin, "today");
  browser = new FirebaseDataStringField<UserDeviceData>("browser", t("main.browser"), (userDevice) => userDevice.browser, "web");

  allFields(): DataObjectField<any, UserDeviceData>[] {
    return [this.platform, this.model, this.osVersion, this.lastLogin, this.browser];
  }
  displayName(): string {
    return t("main.userDevice");
  }

  override getAllDatas(): UserDeviceData[] {
    if (LocalData.currentUser.devices !== undefined) {
      return LocalData.currentUser.devices.documents;
    } else {
      return [];
    }
  }

  loadAll(): Promise<any> {
    const promise = new Promise<UserDeviceData[]>((resolve) => {
      LocalData.currentUser.devices?.load((userDevices) => {
        resolve(userDevices);
      });
    });

    return promise;
  }

  getAllDataTableDatas(documents: UserDeviceData[]): DataTableData[] {
    return documents.map((userDevice) => {
      return {
        key: userDevice.id,
        cells: {
          platform: {
            element: <StatusTag text={userDevice.platform} color={getColorForPlatform(userDevice.platform)} />,
            rawString: userDevice.platform,
          },
          device: userDevice.browser ?? userDevice.model,
          osVersion: userDevice.osVersion,
          lastLogin: userDevice.lastLogin,
        },
      };
    });
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "platform",
        title: t("main.platform"),
      },
      {
        key: "device",
        title: t("main.model"),
      },
      {
        key: "osVersion",
        title: t("main.osVersion"),
      },
      {
        key: "lastLogin",
        title: t("main.lastLogin"),
      },
    ];
  }
}

